import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCategoryConfigurationById } from "./actions";

export const categoryConfigurationEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?.category || entity?.name,
});

const initialState = categoryConfigurationEntityAdapter.getInitialState({});

export const categoryConfigurationSlice = createSlice({
  name: "categoryConfiguration",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCategoryConfigurationById.fulfilled, (state, action) => {
      if (action.payload?.status && action.payload?.data) {
        categoryConfigurationEntityAdapter.upsertOne(state, action.payload.data);
      } else {
        console.error("Invalid payload received in categoryConfiguration:", action.payload);
      }
    });
  },
});

export default categoryConfigurationSlice.reducer;
